// Cache-key helpers for the /season page.

export function seasonalityCacheKey(): string {
  return 'seasonality'
}
